import { connect } from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import RootState from '../../modules/rootState';
import ContractAgreement, { StateFromProps, DispatchFromProps, OwnProps } from './ContractAgreement';
import * as agreeTermsData from 'src/modules/entities/agreeTerms';
import * as workflowData from 'src/modules/entities/workflow';
import { AgreeTermsRequest } from 'src/models/agreeTerms';

const mapStateToProps = (rootState: RootState, props: OwnProps): StateFromProps => ({
    registrationId: workflowData.selectors.getRegistrationId(rootState),
    sessionId: workflowData.selectors.getSessionId(rootState),
    workflow: workflowData.selectors.getWorkflow(rootState),

    submitting: agreeTermsData.selectors.submitting(rootState),
    submitted: agreeTermsData.selectors.submitted(rootState),
    termsAgreed: agreeTermsData.selectors.termsAgreed(rootState),
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchFromProps => ({
    submitAgreeTerms: (agreeTerms: AgreeTermsRequest): void => {
        dispatch(agreeTermsData.actions.submitAgreeTermsAsync(agreeTerms));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractAgreement);


// WEBPACK FOOTER //
// ./src/components/ContractAgreement/ContractAgreement.container.ts